import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProductService } from '../../../services/product.service';
import { ActivatedRoute, NavigationEnd, Router, RouterEvent } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FavouritesService } from '../../../services/favourites.service';
import { Store } from '../../../store';
import { BreadcrumbsService } from '../../../services/breadcrumbs.service';
import { SeoService } from 'src/app/services/seo.service';

@Component({
    selector: 'app-product-group-detail',
    templateUrl: './product-group-detail.component.html',
    styleUrls: ['./product-group-detail.component.scss']
})
export class ProductGroupDetailComponent implements OnInit, OnDestroy {
    favourites$ = this.store.select<any[]>('favourites');
    settings$ = this.store.select<any>('settings');

    productGroup;
    products = [];
    isLoaded = false;
    rewardDiscount;
    public destroyed = new Subject<any>();
    user = this.store.selectForLocal('user');

    constructor(
        private store: Store,
        private route: ActivatedRoute,
        private router: Router,
        private productsService: ProductService,
        private favouritesService: FavouritesService,
        private breadcrumbsService: BreadcrumbsService,
        private seoService: SeoService,
    ) {
    }
    
    ngOnInit(): void {
       

        this.getProductGroups();

        this.router.events.pipe(
            filter((event: RouterEvent) => event instanceof NavigationEnd),
            takeUntil(this.destroyed)
        ).subscribe(() => {
            this.getProductGroups();
        });
    }

    ngOnDestroy(): void {
        this.destroyed.next();
        this.destroyed.complete();
    }

    getProductGroups() {
        this.productsService.getProductGroup(this.route.snapshot.params.slug).subscribe(data => {
            this.productGroup = data.data;
            this.isLoaded = true;
            this.breadcrumbsService.changeBreadcrumb([
                { text: 'Our Products', route: ['/product-groups'] },
                { text: this.productGroup.name }
            ]);
            this.setMetaTags(data.data);
            this.productsByGroup(this.productGroup);
        }, error => {
            this.isLoaded = true;
        });
    }

    productsByGroup(productGroup) {
        this.productsService.productsByGroup(productGroup).subscribe(data => {
            this.products = data.data;
            if(this.user){
                
                this.rewardDiscount = this.user.rewardDiscount;
            }else{
                this.rewardDiscount = 0;

            }
            
            // if (this.products.length === 1) {
            //     this.router.navigate(['/products', this.products[0].slug]);
            // }
        });
    }

    toggleFavourite(productId) {
        const favourites = this.store.selectForLocal('favourites');
        if (favourites.indexOf(productId) < 0) {
            this.favouritesService.addToFavourites(productId);
        } else {
            this.favouritesService.deleteFavourite(productId);
        }
    }

    setMetaTags(productGroup) {
        this.seoService.updateTitle(productGroup.seoTitle);
        this.seoService.addMetaTag('description', productGroup.seoDescription);
        this.seoService.createLinkForCanonicalURL();
    }

}
